/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { Layout, Spin } from 'antd';

import { CloseCircleOutlined, ExportOutlined, VerticalAlignMiddleOutlined } from '@ant-design/icons';
// eslint-disable-next-line
import { Resizable } from 'react-resizable';
import UserManagement from '../../pages/user-management';
import {
  USER_MANAGEMENT_PATH,
  USER_DETAILS_PATH,
  TENANT_PATH,
  ACCOUNT_PATH,
  USER_CREATION_PATH,
  ASSET_DATA_IMPORT_PATH,
  CHANGE_PASSWORD_PATH,
  REPORTS_LIST_PATH,
  MANAGE_GROUP_TYPE_PATH,
  DATA_MODEL_TYPE_PATH,
  CREATE_GROUP_TYPE_PATH,
  CREATE_REPORT_PATH,
  EDIT_REPORT_PATH,
  EDIT_GROUP_TYPE_PATH,
  DEVICE_CONFIG_PATH,
  RULES_CONFIG_PATH,
  CREATE_DEVICE_PATH,
  EDIT_DEVICE_PATH,
  CREATE_REPORT_GROUP_PATH,
  EDIT_REPORT_GROUP_PATH,
  MAP_REPORT_PATH,
  DATA_MODEL_EDIT_PATH,
  DATA_MODEL_DIAGRAM_PATH,
} from '../paths.constants';
import Sidebar from '../../lib/sidebar';
import './authorized.routing.less';
import Tenant from '../../pages/tenants';
import UserDetails from '../../pages/user-details';
import UserCreation from '../../pages/user-creation';
import AssetTypes from '../../pages/asset-types';
import CreateGroup from '../../pages/create-group';
import Account from '../../pages/account';
import ChangePassword from '../../pages/change-password/change-password.page';
import ManageGroupTypes from '../../pages/manage-group-types';
import ErdEdit from '../../pages/manage-data-model-types/edit-erd/erd-edit.page';
import CreateGroupType from '../../pages/create-group-type';
import CreateReport from '../../pages/create-report';
import EditReport from '../../pages/edit-report';
import MapReport from '../../pages/map-report';
import AssetDetails from '../../pages/asset-details';
import Devices from '../../pages/devices';
import Rules from '../../pages/rules/rules.page';
import DeviceDetails from '../../pages/device-details';
import ReportsRouting from './reports.routing';
import CreateReportGroup from '../../pages/create-report-group';
import SchemaEditor from '../../pages/manage-data-model-types/edit-erd/schema-editor';
import Erd from '../../pages/manage-data-model-types/erd/erd.page';
// import { ReactComponent as FoldersBtn } from '../../../assets/icons/foldersBtn.svg';
import { useStore } from '../../../store';
import { useActions } from '../../providers/actions-provider/actions.context';
import { USER_PERMISSIONS } from '../../../store/modules/user/user.constants';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';

/* eslint-disable */
interface IFrameProps {
  src?: string;
  children?: React.ReactNode,
}
export const IFrame = (props: IFrameProps) => {
  const [contentRef, setContentRef] = useState<any>(null)
  const mountNode =
    contentRef?.contentWindow?.document?.body

  return (
    <iframe {...props} ref={setContentRef} style={{ padding: '3px', width: '100%', height: '100%', border: '0' }}>
      {mountNode && props.children && createPortal(props.children, mountNode)}
    </iframe>
  )
}
/* eslint-enable */

const AuthorizedRouting: React.FC = () => {
  const localStorageService = useLocalStorage();
  const [barIsCollapsed, setBarCollapse] = useState(false);
  const [treeIsVisible, setTreeVisible] = useState(false);
  const [helpWidth, setHelpWidth] = useState(500);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const permissions: { [key: string]: any } | null = localStorageService.get(USER_PERMISSIONS);
  // const { reportsTree, help } = useStore();
  const { help } = useStore();
  const { userActions } = useActions();
  const {
    permission,
  } = useStore();
  useEffect(() => {
    if (!permission.loaded && !permissions) {
      userActions.getPermission();
    }
  }, []);

  const onCloseHelp = () => {
    userActions.toggleHelp();
  };
  const borderHelp = help.displayed ? '2px solid gray' : '0';

  // eslint-disable-next-line
  const onResize = (event: any, {element, size, handle}: any) => {
    setHelpWidth(size.width);
  };

  // eslint-disable-next-line
  function renderResizeHandle(resizeHandle: any, ref: any) {
    return (
      <div
        ref={ref}
        style={{
          position: 'absolute',
          cursor: 'col-resize',
          height: 25,
          width: 25,
          userSelect: 'none',
          top: document.body.clientHeight / 2,
          left: -10,
          color: 'gray',
          display: help.displayed ? 'block' : 'none',
        }}
      >
        <VerticalAlignMiddleOutlined rotate={90} style={{ fontSize: '18px' }} />
      </div>
    );
  }

  function renderHelpContent() {
    if (help.loading) {
      return (
        <Spin style={{ paddingTop: '60px' }} />
      );
    }
    return (
      <div style={{ width: '100%', height: '100%' }}>
        {help.data.url && (
          <IFrame src={help.data.url} />
        )}
      </div>
    );
  }

  return (
    <Layout style={{ height: '100vh' }}>
      <Sidebar collapsedBar={barIsCollapsed} collapseHandler={setBarCollapse} />
      {/* TODO: It will reimplement report sider */}
      {/* <Layout.Sider style={{ background: 'white' }}>
        Report Tree
      </Layout.Sider> */}
      <Switch>
        <Route path={ACCOUNT_PATH} component={Account} exact />
        <Route path={`${ACCOUNT_PATH}${CHANGE_PASSWORD_PATH}`} component={ChangePassword} exact />
        <Route path={USER_MANAGEMENT_PATH} component={UserManagement} exact />
        <Route path={USER_CREATION_PATH} component={UserCreation} exact />
        <Route path={`${USER_DETAILS_PATH}/:id`} component={UserDetails} exact />
        <Route path={[`${TENANT_PATH}/:id*/createGroup`, `${TENANT_PATH}/:id*/editGroup`]} exact component={CreateGroup} />
        <Route path={[TENANT_PATH, `${TENANT_PATH}/:id*`]} render={() => <Tenant key={window.location.pathname} />} exact />
        <Route path={[`${REPORTS_LIST_PATH}:id*/:id*${CREATE_REPORT_GROUP_PATH}`, `${REPORTS_LIST_PATH}:id*/:id*${EDIT_REPORT_GROUP_PATH}`]} component={CreateReportGroup} />
        <Route path={`${REPORTS_LIST_PATH}${EDIT_REPORT_PATH}`} component={EditReport} />
        <Route path={`${REPORTS_LIST_PATH}${MAP_REPORT_PATH}`} component={MapReport} />
        <Route path={`${REPORTS_LIST_PATH}${CREATE_REPORT_PATH}`} component={CreateReport} />
        <Route
          path={REPORTS_LIST_PATH}
          render={(props) => (
            <>
              {/* {!barIsCollapsed && ( */}
              {/* {!treeIsVisible && reportsTree.data.length && (
                <button
                  style={{
                    width: 32,
                    padding: 0,
                    height: 32,
                    borderRadius: 8,
                    position: 'absolute',
                    top: 176,
                    left: !barIsCollapsed ? 272 : 75,
                  }}
                  onClick={() => setTreeVisible(!treeIsVisible)}
                  type="button"
                >
                  <FoldersBtn />
                </button>
              )} */}
              {/* )} */}
              <ReportsRouting
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                collapsedBar={treeIsVisible}
                collapseHandler={setTreeVisible}
              />
            </>
          )}
        />
        <Route path={`${EDIT_GROUP_TYPE_PATH}/:id`} component={CreateGroupType} exact />
        <Route path={`${USER_DETAILS_PATH}/:id`} component={UserDetails} exact />
        <Route path={ASSET_DATA_IMPORT_PATH} component={AssetTypes} exact />
        <Route path={`${ASSET_DATA_IMPORT_PATH}/:id`} component={AssetDetails} exact />
        <Route path={MANAGE_GROUP_TYPE_PATH} component={ManageGroupTypes} exact />
        <Route path={DATA_MODEL_TYPE_PATH} component={ErdEdit} exact />
        <Route path={CREATE_GROUP_TYPE_PATH} component={CreateGroupType} exact />
        <Route path={DEVICE_CONFIG_PATH} component={Devices} exact />
        <Route path={RULES_CONFIG_PATH} component={Rules} exact />
        <Route path={[CREATE_DEVICE_PATH, `${EDIT_DEVICE_PATH}/:id`]} component={DeviceDetails} exact />
        <Route path={`${DATA_MODEL_EDIT_PATH}/:id`} component={SchemaEditor} exact />
        <Route path={`${DATA_MODEL_DIAGRAM_PATH}/:id`} component={Erd} exact />
        <Redirect to={REPORTS_LIST_PATH} />
      </Switch>

      {help.displayed && (
        <Resizable
          width={helpWidth}
          height={document.body.clientHeight}
          onResize={onResize}
          resizeHandles={['w']}
          handle={renderResizeHandle}
        >
          <Layout.Sider
            style={{ background: 'white', borderLeft: borderHelp, maxHeight: '100vh' }}
            collapsed={!help.displayed}
            collapsible
            collapsedWidth={0}
            trigger={null}
            width={helpWidth}
          >
            <div style={{
              display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px',
            }}
            >
              <CloseCircleOutlined
                style={{ fontSize: '18px' }}
                onClick={onCloseHelp}
              />
              <a href={`${help.data.url}`} target="_blank" rel="noreferrer">
                <strong style={{ color: 'blue', fontWeight: 'normal' }}>Open in new Tab</strong>
                <ExportOutlined style={{ fontSize: '18px', padding: '0px 5px' }} />
              </a>
            </div>
            {renderHelpContent()}
          </Layout.Sider>
        </Resizable>
      )}
    </Layout>
  );
  // eslint-enable
};

AuthorizedRouting.displayName = 'AuthorizedRouting';

export default AuthorizedRouting;
